
import { Vue, Component } from 'vue-property-decorator';
import { component as Viewer } from 'v-viewer';

@Component({
  components: {
    Viewer,
  },
})
export default class ImageViewer extends Vue {
  visible = false;
}
